import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/free-solid-svg-icons";

const ProcessingVideoIcon = (props) => { 

    return (
    <div data-testId="progress-video-icon" className={Classes.productProcessingVideoIconContainer}>
        <FontAwesomeIcon icon={faVideo} className={Classes.productProcessingVideoIcon}/>
        <p>{props.text}</p>
    </div>
)};

ProcessingVideoIcon.propTypes = {
  text: PropTypes.string.isRequired
};

export default ProcessingVideoIcon;
